import type { Batch } from '@ctcells/contract'
import { useChosenStripBatchId } from '@ctcells/core'
import { createContext, useContext } from 'react'

import { pickStripBatch } from './batchStripModel.ts'

/**
 * **작업 줄에 무엇을 띄우나 — 표면 정책 한 곳.**
 *
 * 통합 콘솔은 «사람이 고른 작업만» 띄운다(eric 2026-10-22 「작업 선택을 누르면 드롭다운 리스트가 나와.. 이걸 선택하기 전에는
 * 대기 이런 게 당연히 나오면 안 돼.. 드롭다운 리스트 선택을 하면 해당 작업의 이름이 화면에 표기되게 돼.. 바로 시작하는 게 아니라
 * 작업자가 시작을 눌러야 그때 시작이 돼.」). 차례는 **시작한 작업 → 고른 작업 → 없음**이다.
 * 다른 표면(장비 관점 콘솔 · 태블릿)은 종전대로 **시작한 작업 → 서버 차례 첫 건**이다 — 이 문맥을 열지 않는다.
 *
 * 🔴 **셸만 연다**(`ConsoleLayout`). 화면은 이 값을 직접 읽지 않고 `useStripBatch` 를 부른다 — 작업 줄 · 모니터링 따라가기 ·
 *    시료 흐름 · 모니터링 챔버가 **같은 작업**을 말해야 한 화면이 두 말을 하지 않는다.
 * 🔴 고르는 것은 시작이 아니다 — 고른 값은 클라 상태(`useStripChoiceStore`)일 뿐이고, 시작은 [시작](제어락 · 사전 점검)을 사람이 눌러야 나간다.
 */
export const ExplicitStripPickContext = createContext(false)

/** 이 표면이 «사람이 고른 작업만 띄우는» 표면인가 — [작업 선택] 드롭다운도 이 값으로 선다 */
export function useExplicitStripPick(): boolean {
  return useContext(ExplicitStripPickContext)
}

/** 작업 줄에 띄울 한 건 — 고른 값 · 표면 정책을 같이 읽는다. 목록은 부르는 쪽이 이미 받은 활성 목록이다(새 조회 없음) */
export function useStripBatch(items: readonly Batch[]): Batch | undefined {
  const chosen = useChosenStripBatchId()
  const explicit = useExplicitStripPick()
  return pickStripBatch(items, chosen, { fallbackFirst: !explicit })
}
